export default "/react/tBankIcon-716bbb99.svg";